import React from 'react';
import { InputNumber as AntdInputNumber, InputNumberProps as AntInputNumberProps } from 'antd';

import './input-number.scss';

interface InputNumberProps extends AntInputNumberProps {
	error?: string;
}

const InputNumber = ({ error, ...otherProps }: InputNumberProps) => {
	return (
		<div className="bringg-input-number">
			<AntdInputNumber {...otherProps} />
			{error && <div className="error-message">{error}</div>}
		</div>
	);
};

export default InputNumber;
